// AudioProvider.jsx
import { createContext, useContext, useRef, useState, useEffect } from "react";

const AudioContext = createContext();

export const AudioProvider = ({ children }) => {
  const audioRef = useRef(new Audio("/musica/MusicaFondo.mp3"));
  const [activo, setActivo] = useState(() => {
    return JSON.parse(localStorage.getItem("musicaActiva")) || false;
  });

  useEffect(() => {
    const audio = audioRef.current;
    audio.loop = true;
    audio.volume = 0.2;

    if (activo) audio.play().catch(() => {});
    else audio.pause();

    localStorage.setItem("musicaActiva", JSON.stringify(activo));
  }, [activo]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!audioRef.current.paused) {
        localStorage.setItem("musicaTiempo", audioRef.current.currentTime);
      }
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <AudioContext.Provider value={{ activo, setActivo }}>
      {children}
    </AudioContext.Provider>
  );
};

export const useAudio = () => useContext(AudioContext);